import { ApiResourceBase } from '@anny.co/vue-jsonapi-orm'

/**
 * Api Resource class.
 * hold static method for fetching
 */
export class ApiResource extends ApiResourceBase {
  static apiPath = ''
}
